import { Link } from "react-router-dom";
import { Mail, Facebook, MapPin, Heart } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-cb-black text-white border-t-3 border-cb-black">
    <div className="max-w-7xl mx-auto px-4 py-12 grid gap-10 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <img src="/logo.jpg" alt="Crazy Buns logo" className="w-14 h-14 rounded-full border-3 border-white object-cover" />
          <span className="font-display font-bold text-2xl uppercase">
            Crazy <span className="text-cb-pink">Buns</span>
          </span>
        </div>
        <p className="text-white/70 font-bold text-sm max-w-xs">
          Warm cinnamon rolls, biscuits & gravy, and fresh coffee — served with big smiles from our bright little trailer.
        </p>
        <p className="mt-4 font-display font-semibold uppercase text-cb-yellow tracking-wide">Life is better with a bun!</p>
      </div>

      <div>
        <h3 className="font-display font-semibold uppercase tracking-widest text-cb-teal mb-4">Roll Around</h3>
        <ul className="space-y-2 font-bold text-sm">
          <li><Link data-testid="footer-home-link" className="hover:text-cb-yellow transition-colors" to="/">Home</Link></li>
          <li><Link data-testid="footer-story-link" className="hover:text-cb-yellow transition-colors" to="/story">Our Story</Link></li>
          <li><Link data-testid="footer-menu-link" className="hover:text-cb-yellow transition-colors" to="/menu">Menu</Link></li>
          <li><Link data-testid="footer-book-link" className="hover:text-cb-yellow transition-colors" to="/book">Book Crazy Buns</Link></li>
          <li><Link data-testid="footer-truck-link" className="hover:text-cb-yellow transition-colors" to="/truck">Find The Truck</Link></li>
        </ul>
      </div>

      <div>
        <h3 className="font-display font-semibold uppercase tracking-widest text-cb-teal mb-4">Say Hello</h3>
        <a
          data-testid="footer-email-link"
          href="mailto:crazybuns88@gmail.com"
          className="flex items-center gap-2 font-bold text-sm hover:text-cb-yellow transition-colors"
        >
          <Mail className="w-4 h-4 text-cb-pink" /> crazybuns88@gmail.com
        </a>
        <a
          data-testid="footer-facebook-link"
          href="https://www.facebook.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 flex items-center gap-2 font-bold text-sm hover:text-cb-yellow transition-colors"
        >
          <Facebook className="w-4 h-4 text-cb-pink" /> Follow the truck on Facebook
        </a>
        <Link
          data-testid="footer-truck-cta"
          to="/truck"
          className="mt-5 inline-flex items-center gap-2 cb-btn cb-btn-teal !text-xs !px-5 !py-2.5"
        >
          <MapPin className="w-4 h-4" /> Where are we today?
        </Link>
      </div>
    </div>
    <div className="border-t border-white/15 py-4 text-center text-xs font-bold text-white/50">
      <span className="inline-flex items-center gap-1">
        © {new Date().getFullYear()} Crazy Buns Food Truck — made with <Heart className="w-3 h-3 text-cb-pink fill-cb-pink" /> and extra icing
      </span>
      <Link data-testid="footer-admin-link" to="/admin" className="ml-3 text-white/30 hover:text-cb-teal transition-colors">Owner Login</Link>
    </div>
  </footer>
);
